import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SnackbarComponent } from '../../../shared/snackbar/snackbar.component';

@Component({
  selector: 'app-order-dialog',
  templateUrl: './order-dialog.component.html',
  styleUrls: ['./order-dialog.component.css']
})
export class OrderDialogComponent implements OnInit {
  productInfo:any;
  total:any=0;
  subTotal:any=0;
  couponData:any;
  constructor(
    public dialogRef: MatDialogRef<OrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toast:SnackbarComponent
    ) { 
   
  }

  ngOnInit() {
    console.log(this.data);
    this.total = 0;
    this.subTotal = 0;
    this.productInfo = this.data.productInfo;
    this.couponData = this.data.couponData;
    this.productInfo.map((element)=>{
      this.total += element.productDetail.retail_price;
      this.subTotal += element.productDetail.retail_price;
    })
    if(this.couponData){
      this.total -= this.couponData.amount;     
     }
  }
  onNoClick(): void {
    this.dialogRef.close("no");
  }

  submit(){
   
  }

}
